import { apiRequest, getAccessToken } from './auth.js';

// Провайдер статистики InfoBasket (совпадает с CompetitionStatisticsProvider.InfoBasket).
export const PROVIDER_INFOBASKET = 1;

// Запрашивает состояние конкурсов прогнозов для набора игр.
// Возвращает объект { [providerId]: BettingInfo, ... }.
export async function fetchBettings(ids) {
	const list = (ids || []).map((id) => String(id)).filter(Boolean);
	if (!list.length) return {};

	const payload = await apiRequest('betting/bettings', {
		method: 'POST',
		accessToken: getAccessToken(),
		body: { ids: list, provider: PROVIDER_INFOBASKET }
	});

	const items = Array.isArray(payload) ? payload : payload?.$values || payload?.items || [];
	const map = {};
	for (const item of items) {
		if (item?.providerId !== null && item?.providerId !== undefined) {
			map[String(item.providerId)] = item;
		}
	}
	return map;
}

// Вычисляет процентное соотношение ставок на первую и вторую команду.
export function getBetPercentages(info) {
	const result1 = Number(info?.result1Bets) || 0;
	const result2 = Number(info?.result2Bets) || 0;
	const total = result1 + result2;
	if (!total) return { p1: 0, p2: 0, total: 0 };
	const p1 = Math.round((result1 / total) * 100);
	const p2 = 100 - p1;
	return { p1, p2, total };
}

// Делает ставку на результат матча.
export async function makeBet({ projectId, providerId, bettingDate, result1Name, result2Name, bet }) {
	return apiRequest('betting/bet', {
		method: 'POST',
		accessToken: getAccessToken(),
		body: {
			projectId,
			providerId: String(providerId),
			bettingDate,
			provider: PROVIDER_INFOBASKET,
			result1Name,
			result2Name,
			bet
		}
	});
}

// Запрашивает таблицу лидеров конкурса прогнозов.
export async function fetchLeaderboard({ projectId, start, end }) {
	const payload = await apiRequest('betting/leaderboard', {
		method: 'POST',
		body: { projectId, start, end }
	});
	return Array.isArray(payload) ? payload : payload?.$values || payload?.items || [];
}

// Определяет дату матча для ставки из объекта с данными о дате/времени.
export function resolveBettingDate(source) {
	if (!source) return new Date().toISOString();
	const candidates = [source.start, source.startTime, source.defaultZoneDateTime];
	for (const candidate of candidates) {
		if (candidate) {
			const date = new Date(candidate);
			if (!Number.isNaN(date.getTime())) return date.toISOString();
		}
	}
	if (source.localDate) {
		const date = new Date(`${source.localDate}T00:00:00`);
		if (!Number.isNaN(date.getTime())) return date.toISOString();
	}
	return new Date().toISOString();
}
